/* ================================================== */
/* ACCESSIBILITY > Disable Tabindex
/* ================================================== */

function disableTabindex(parent) {
	$('a, [tabindex]:not([tabindex="-1"])').each(function(index, element) {
		if (typeof parent === 'undefined' 
			|| (typeof parent !== 'undefined' && !$(element).parents(parent).length)) {
			var tabindex = ($(element).attr('tabindex')) ? '' + $(element).attr('tabindex') : '0';
			$(element).attr('data-tabindex', tabindex).attr('tabindex', '-1');
		}
	});
}